/**
 * City Model Interface
 * Framework-agnostic TypeScript interface
 */

export interface City {
  city_id?: number;
  id?: number;
  city_name: string;
  pincode?: string;
  state_id?: number;
  state_code?: string;
  state_name?: string;
  region_id?: number;
  region_name?: string;
  latitude?: string;
  longitude?: string;
  created_at?: string;
  updated_at?: string;
  active?: number | boolean;
  program_id?: number;
}

export interface CityFormData {
  id?: number;
  city_id?: number;
  city_name: string;
  state_code: string;
  state_id?: number;
  pincode?: string;
  latitude?: string;
  longitude?: string;
}

export interface CityApiResponse {
  data: {
    cities: City[];
  };
  message?: string;
  success?: boolean;
}
